import "./Radio.css";

const Radio = ({
  label,
  name,
  value,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className={`ui-radio ${disabled ? "disabled" : ""}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      <span className="ui-radio-circle" />

      {label && <span>{label}</span>}
    </label>
  );
};

export default Radio;